import { render, staticRenderFns } from "./SignUpRegister.vue?vue&type=template&id=1f63687e"
import script from "./SignUpRegister.vue?vue&type=script&lang=js"
export * from "./SignUpRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports